module.exports = __webpack_public_path__ + "img/install-profile-animation-b979e40c4dbc7b908dd819616100a282.gif";